import React from "react";
import myVideo from "../../assets/how-to-take.mp4";
import { useTranslation } from "react-i18next";
import {
  Policy,
  QuizFirstSlideDesc1,
  QuizFirstSlideDesc2,
  QuizFirstSlideTitle,
  TakeTheTestButton,
} from "../../Constants";

const FirstSlide = ({ handleClick }) => {
  const { t } = useTranslation();
  return (
    <div className="t-p-4 t-flex t-flex-col t-gap-2">
      <video
        src={myVideo}
        autoPlay
        muted
        loop
        playsInline
        controls={false} // remove this if you don't want controls
        className="t-w-[200px] t-h-[250px] md:t-w-[300px] md:t-h-[350px] t-mx-auto t-object-cover"
      />
      <div className="t-flex t-flex-col md:t-items-center md:t-justify-center t-max-w-[500px] t-mx-auto">
        <h1
          className="t-text-base t-font-extrabold t-mt-4  md:t-text-center"
          style={{ fontFamily: "roboto" }}
        >
          {t(QuizFirstSlideTitle)}
        </h1>
        <p className="!t-m-0 t-text-base  md:t-text-center">
          {t(QuizFirstSlideDesc1)}
        </p>
        <p className="!t-m-0 t-text-base  md:t-text-center">
          {t(QuizFirstSlideDesc2)}
        </p>
      </div>
      <a
        href="/policy"
        target="_blank"
        className="t-text-center !t-text-gray-500 t-underline"
      >
        {t(Policy)}
      </a>
      <button
        className="t-hidden md:t-flex t-items-center t-justify-center t-mt-8 t-bg-secondary t-w-full t-max-w-[500px] !t-ml-auto !t-text-lg !t-h-[50px] !t-rounded-lg t-text-white t-mx-auto"
        onClick={handleClick}
      >
        {t(TakeTheTestButton)}
      </button>
      <div
        className="md:t-hidden t-fixed t-bottom-0 t-left-0 !t-w-full t-bg-white t-p-4 t-rounded-[20px_20px_0_0] t-flex t-justify-center"
        style={{ boxShadow: "0 0 10px 10px #efefef" }}
      >
        <button
          onClick={handleClick}
          className="t-bg-secondary t-w-full t-max-w-[300px] !t-text-base !t-h-[50px] !t-rounded-lg t-text-white"
        >
          {t(TakeTheTestButton)}
        </button>
      </div>
    </div>
  );
};

export default FirstSlide;
